export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '商机ID',
      dataIndex: 'id',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    { title: '客户姓名', dataIndex: 'name', width: 160, ellipsis: true },
    { title: '客户电话', dataIndex: 'phone', width: 160 },
    { title: '是否注册会员', dataIndex: 'memberFlag', width: 160, render: (v:boolean) => v ? '是' : '否' },
    { title: '客户标签', dataIndex: 'customerTags', width: 200, render: (v) => v?.join(', '), ellipsis: true },
    { title: '最后跟进时间', dataIndex: 'lastFollowTime', width: 180, itemType: 'dateTime' },
    { title: '操作', dataIndex: '#', width: 150, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    { label: '客户姓名', name: 'nameLike' },
    { label: '客户电话', name: 'phone' },
    {
      label: '是否注册会员',
      name: 'memberFlag',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        { value: true, label: '是' },
        { value: false, label: '否' },
      ],
    },
    {
      name: 'lastFollowTime',
      label: '最后跟进时间',
      placeholder: ['最后跟进时间起', '止'],
      itemType: 'autoDate',
      showTime: 'true',
      colSpan: 2,
      searchFormConfig: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
          xl: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
          xl: { span: 19 },
        },
      },
    },
  ],
  // footer: [
  //   {
  //     label: '新增',
  //     type: 'primary',
  //     events: ['onClick:onAdd'],
  //   },
  // ],
}
